// Core
import { useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'

const useModal = (modalClassName, child, destination = document.body) => {
    const createModal = () => {
        const root = document.createElement('div')
        if (modalClassName) {
            root.className = modalClassName
        }
        return root
    }

    const ModalRef = useRef(createModal())

    // Add new div in our body with className 'modal'
    useEffect(() => {
        destination.appendChild(ModalRef.current)
        const modalNode = ModalRef.current
        return () => {
            destination.removeChild(modalNode)
        }
    }, [destination])

    const controller = {
        Modal: () => (ModalRef.current ? ReactDOM.createPortal(child, ModalRef.current) : null),
    }

    return controller
}

export default useModal
